import script from "./shippingorderInformation.vue?vue&type=script&setup=true&lang=js"
export * from "./shippingorderInformation.vue?vue&type=script&setup=true&lang=js"

import "./shippingorderInformation.vue?vue&type=style&index=0&id=eb713696&lang=scss&scoped=scoped"

import exportComponent from "C:\\Users\\23586\\Desktop\\美国站\\h5\\us-station-number\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb713696"]])

export default __exports__